// Códigos de proceso fonológico del TEPROSIF-R.
//
// La autoridad es el servidor: `FUNCIONES` en newredpsi
// (apps/teprosif/models.py), que es quien asigna los códigos al corregir las
// emisiones. Los nombres de abajo son los de ese dict, y su orden es el del
// manual publicado (Pavez, Maggiolo & Coloma).
//
// Esta lista es de solo lectura: alimenta el tooltip del chip que muestra cada
// proceso detectado. Nadie edita códigos en la plataforma — el servidor los
// detecta y la profesional los revisa en pantalla.
//
// Si el servidor gana códigos nuevos, hay que agregarlos acá: un código sin
// entrada se muestra desnudo, sin nombre clínico. Lo definitivo es que el
// servidor mande su propio dict en la respuesta, y ahí este archivo sobra.

export const PROC_GROUPS = [
  {
    key: "est",
    label: "Estructura silábica",
    opts: [
      { v: "E1", l: "E1 · Reducción del grupo consonántico" },
      { v: "E2", l: "E2 · Reducción de diptongo" },
      { v: "E3", l: "E3 · Omisión de consonante trabante" },
      { v: "E4", l: "E4 · Coalescencia" },
      { v: "E5", l: "E5 · Omisión de elementos átonos" },
      { v: "E6", l: "E6 · Omisión de sílaba tónica o alguno de sus constituyentes" },
      { v: "E7", l: "E7 · Adición de fonemas o sílabas" },
      { v: "E8", l: "E8 · Inversión de fonemas o sílabas" },
    ],
  },
  {
    key: "asim",
    label: "Asimilación",
    opts: [
      { v: "A1", l: "A1 · Asimilación idéntica" },
      { v: "A2", l: "A2 · Asimilación labial" },
      { v: "A3", l: "A3 · Asimilación dental" },
      { v: "A4", l: "A4 · Asimilación palatal" },
      { v: "A5", l: "A5 · Asimilación velar" },
      { v: "A6", l: "A6 · Asimilación a fonemas líquidos" },
      { v: "A7", l: "A7 · Asimilación nasal" },
      { v: "A8", l: "A8 · Asimilación vocálica" },
      { v: "A9", l: "A9 · Asimilación silábica" },
    ],
  },
  {
    key: "sust",
    label: "Sustitución",
    opts: [
      { v: "S1", l: "S1 · Aspiración de fonema trabante de sílaba" },
      { v: "S2", l: "S2 · Posteriorización de labiales y dentales" },
      { v: "S3", l: "S3 · Frontalización de palatales y velares" },
      {
        v: "S4",
        l: "S4 · Labialización de consonantes que no son palatales, velares ni líquidos",
      },
      { v: "S5", l: "S5 · Oclusivización de fonemas fricativos o africados" },
      { v: "S6", l: "S6 · Fricativización de fonemas oclusivos o africados" },
      { v: "S7", l: "S7 · Sustitución de fricativos entre sí" },
      { v: "S8", l: "S8 · Sonorización de consonantes" },
      { v: "S9", l: "S9 · Afonización o pérdida de sonoridad de consonantes" },
      { v: "S10", l: "S10 · Semiconsonantización de fonemas líquidos" },
      { v: "S11", l: "S11 · Sustitución de fonemas líquidos entre sí" },
      { v: "S12", l: "S12 · Sustitución de fonemas líquidos por no líquidos orales" },
      {
        v: "S13",
        l: "S13 · Sustitución de fonemas no líquidos orales o vocálicos por fonemas líquidos",
      },
      { v: "S14", l: "S14 · Nasalización de fonemas" },
      { v: "S15", l: "S15 · Oralización de consonantes nasales" },
      { v: "S16", l: "S16 · Sustitución de vocales o disimilación" },
    ],
  },
];

export const PROCESS_SUFFIXES = ["EA", "EB", "EC", "AA", "AB", "AC", "SA", "SB", "SC"];
